
// import React, { useEffect, useState } from 'react';
// import { useParams, useHistory } from 'react-router-dom';
// import { obtenerEncuesta } from '../../actions/EncuestaAction';
// import { Typography, Button, Paper, Box, List } from '@mui/material';
// import style from '../Tools/Style';

// const VerEncuesta = () => {
//   const { encuestaId } = useParams();
//   const history = useHistory();
//   const [encuesta, setEncuesta] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     obtenerEncuesta(encuestaId)
//       .then(response => {
//         setEncuesta(response.data);
//         setLoading(false);
//       })
//       .catch(error => {
//         console.error('Error al cargar la encuesta:', error);
//         setLoading(false);
//       });
//   }, [encuestaId]);

//   if (loading) {
//     return (
//       <Typography align="center" color="textSecondary" sx={{ mt: 4 }}>
//         Cargando encuesta...
//       </Typography>
//     );
//   }

//   if (!encuesta) {
//     return (
//       <Typography align="center" color="error" sx={{ mt: 4 }}>
//         No se pudo cargar la encuesta.
//       </Typography>
//     );
//   }

//   return (
//     <Box sx={style.paper}>
//       <Paper elevation={4} sx={{ p: 4, width: '70%' }} >
//         <Typography variant="h4" fontWeight="bold" gutterBottom>
//           {encuesta.titulo}
//         </Typography>
//         <Typography variant="subtitle1" color="textSecondary" gutterBottom>
//           {encuesta.descripcion || 'Sin descripción'}
//         </Typography>

//         {encuesta.preguntas
//           .sort((a, b) => a.orden - b.orden)
//           .map((pregunta, index) => (
//             <Box key={pregunta.preguntaId} sx={{ mb: 4 }}>
//               <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
//                 {index + 1}. {pregunta.texto}
//               </Typography>
//               <List>
//                   {pregunta.opciones
//               .sort((a, b) => a.orden - b.orden)
//               .map((opcion) => (
//                 <Box key={opcion.opcionId} sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
//                   <input
//                     type="radio"
//                     name={`pregunta_${pregunta.preguntaId}`}
//                     disabled
//                     style={{ marginRight: '8px' }}
//                   />
//                   <Typography>{opcion.texto}</Typography>
//                 </Box>
//               ))}
//               </List>
//             </Box>
//           ))}

//         <Box sx={{ mt: 4, textAlign: 'right' }}>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={() => history.push('/mis-encuestas')}
//             sx={{ ...style.submit, maxWidth: 200 }}
//           >
//             Volver
//           </Button>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default VerEncuesta;

import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { obtenerEncuesta } from '../../actions/EncuestaAction';
import { Typography, Button, Paper, Box, List } from '@mui/material';
import style from '../Tools/Style';

const VerEncuesta = () => {
  const { encuestaId } = useParams();
  const history = useHistory();
  const [encuesta, setEncuesta] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    obtenerEncuesta(encuestaId)
      .then(response => {
        setEncuesta(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error al cargar la encuesta:', error);
        setLoading(false);
      });
  }, [encuestaId]);

  if (loading) {
    return (
      <Typography align="center" color="textSecondary" sx={{ mt: 4 }}>
        Cargando encuesta...
      </Typography>
    );
  }

  if (!encuesta) {
    return (
      <Typography align="center" color="error" sx={{ mt: 4 }}>
        No se pudo cargar la encuesta.
      </Typography>
    );
  }

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'flex-start',
      minHeight: '100vh',
      width: '100%',
      padding: 4,
      paddingTop: 8
    }}>
      <Paper elevation={4} sx={{ p: 4, width: '70%', maxWidth: 500 }} >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          {encuesta.titulo}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          {encuesta.descripcion || 'Sin descripción'}
        </Typography>

        {encuesta.preguntas
          .sort((a, b) => a.orden - b.orden)
          .map((pregunta, index) => (
            <Box key={pregunta.preguntaId} sx={{ mb: 4 }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                {index + 1}. {pregunta.texto}
              </Typography>
              <List>
                  {pregunta.opciones
              .sort((a, b) => a.orden - b.orden)
              .map((opcion) => (
                <Box key={opcion.opcionId} sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                  <input
                    type="radio"
                    name={`pregunta_${pregunta.preguntaId}`}
                    disabled
                    style={{ marginRight: '8px' }}
                  />
                  <Typography>{opcion.texto}</Typography>
                </Box>
              ))}
              </List>
            </Box>
          ))}

        <Box sx={{ mt: 4, textAlign: 'right' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push('/mis-encuestas')}
            sx={{ ...style.submit, maxWidth: 200 }}
          >
            Volver
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default VerEncuesta;